import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ElementEntityPipe } from './entity-type/elementEntity.pipe';
import { LinkifyPipe } from './linkify/linkify.pipe';
import { AmountCalculationPipe } from './amount-calculation/amount-calculation.pipe';
import { CoveredElementsPipe } from './covered-elements/covered-elements.pipe';
import { FixDimensionsPipe } from './fix-dimensions/fix-dimensions.pipe';
import { HighlightSearchPipe } from './highlight-search/highlight-search.pipe';
import { ExponentPipe } from './exponent/exponent.pipe';
import { GradClassPipe } from './grad-class/grad-class.pipe';
import { ScalableProfilesetPipe } from './scalable-profileset.pipe';
import { MpgPercentagePipe } from './mpg-percentage/mpg-percentage.pipe';
import { CategoryPipe } from './category.pipe';
import { LineBreakPipe } from './line-break/linebreak.pipe';
import { DynamicDecimalPipe } from './dynamic-decimal/dynamic-decimal.pipe';
import { PurposeLabelPipe } from './purpose-label/purpose-label.pipe';
import { PhaseLabelPipe } from './phase-label/phase-label.pipe';
import { NumberOrDashPipe } from './numberOrDash/number-or-dash.pipe';
import { NormalizeKeyPipe } from './normalize-key/normalize-key.pipe';
import { DecimalSeparatorPipe } from './decimal-separator/decimal-separator.pipe';

@NgModule({
    declarations: [
        ElementEntityPipe,
        LinkifyPipe,
        AmountCalculationPipe,
        CoveredElementsPipe,
        FixDimensionsPipe,
        HighlightSearchPipe,
        ExponentPipe,
        GradClassPipe,
        ScalableProfilesetPipe,
        MpgPercentagePipe,
        CategoryPipe,
        LineBreakPipe,
        DynamicDecimalPipe,
        PurposeLabelPipe,
        PhaseLabelPipe,
        NumberOrDashPipe,
        NormalizeKeyPipe,
        DecimalSeparatorPipe
    ],
    imports: [CommonModule],
    exports: [
        ElementEntityPipe,
        LinkifyPipe,
        AmountCalculationPipe,
        CoveredElementsPipe,
        FixDimensionsPipe,
        HighlightSearchPipe,
        ExponentPipe,
        GradClassPipe,
        ScalableProfilesetPipe,
        MpgPercentagePipe,
        CategoryPipe,
        LineBreakPipe,
        DynamicDecimalPipe,
        PurposeLabelPipe,
        PhaseLabelPipe,
        NumberOrDashPipe,
        NormalizeKeyPipe,
        DecimalSeparatorPipe
    ]
})
export class PipesModule {
}
